module.exports = __webpack_public_path__ + "static/success-inline-example-20be45eec8ea8cd04cdcb562915a7c8d.svg";